import useAxiosPrivate from '../hooks/useAxiosPrivate';
import { useState, useEffect, useCallback } from 'react';

const useUserApi = (userId) => {
  const axiosPrivate = useAxiosPrivate();
  const [userData, setUserData] = useState(null);

  const getUserById = useCallback(async () => {
    if (!userId) return;

    try {
      const response = await axiosPrivate.get(`/users/${userId}`);
      setUserData(response.data);
    } catch (error) {
      console.error('Error fetching user data:', error);
    }
  }, [axiosPrivate, userId]);

  const refetchUserData = useCallback(() => {
    getUserById();
  }, [getUserById]);

  useEffect(() => {
    getUserById();
  }, [getUserById]);

  return { userData, refetchUserData };
};

export default useUserApi;
